import { Component, Input } from '@angular/core';

@Component({
    selector: 'fcp-icon',
    templateUrl: './fcp-icon.component.html',
    standalone: false
})
export class FcpIconComponent {
    @Input() isCustom: FcpIcon['isCustom'] = false;
    @Input() icon: FcpIcon['icon'];
    @Input() style: FcpIcon['style'];
    @Input() border: FcpIcon['border'] = false;
}

export enum FcpCustomIcons {
    Sort = 'assets/svg/sort-icon.svg',
    Check = 'assets/svg/icon-check.svg'
}

export interface FcpIcon {
    isCustom?: boolean;
    icon: string | Array<string>;
    style?: Partial<CSSStyleDeclaration>;
    border?: boolean;
}
